// "Conexões que pode atender" (user.allowedWhatsappIds): nulo ou vazio = todas (sem restrição).
// Mesmas regras do backend (backend/src/helpers/connectionScope.ts). A tela usa isto para não
// aceitar, pelo tempo real, ticket de conexão que o servidor já não lista para este usuário.

const isConnectionId = (n) => Number.isSafeInteger(n) && n > 0;

const toConnectionId = (value) => {
  if (typeof value === "number") return value;
  if (typeof value === "string" && /^\d+$/.test(value.trim())) return Number(value.trim());
  return NaN;
};

/** Conexões permitidas ao usuário, ou null quando ele não tem restrição. */
export const allowedWhatsappIdsOf = (user) => {
  const raw = user?.allowedWhatsappIds;
  if (!Array.isArray(raw)) return null;
  const ids = [];
  raw.forEach((value) => {
    const id = toConnectionId(value);
    if (isConnectionId(id) && !ids.includes(id)) ids.push(id);
  });
  return ids.length > 0 ? ids : null;
};

export const isConnectionRestricted = (user) => allowedWhatsappIdsOf(user) !== null;

/** Sem restrição: sempre true. Restrito: só ticket de conexão da lista. */
export const canSeeTicketConnection = (user, ticket) => {
  const allowed = allowedWhatsappIdsOf(user);
  if (!allowed) return true;
  const raw = ticket?.whatsappId ?? ticket?.whatsapp?.id;
  if (raw === null || raw === undefined || raw === "") return false;
  return allowed.includes(toConnectionId(raw));
};

/**
 * Evento de tempo real de um ticket que SABIDAMENTE está numa conexão fora da lista (por exemplo,
 * transferido para outra conexão): a tela tira o ticket da lista. Sem restrição, sempre false;
 * evento sem a conexão do ticket também é false (não dá para saber, então não mexe).
 */
export const ticketLeftAllowedConnections = (user, ticket) => {
  const raw = ticket?.whatsappId ?? ticket?.whatsapp?.id;
  if (raw === null || raw === undefined || raw === "") return false;
  return !canSeeTicketConnection(user, ticket);
};

/** Sem restrição devolve a MESMA lista; restrito, só as conexões permitidas. */
export const filterAllowedConnections = (user, list) => {
  const allowed = allowedWhatsappIdsOf(user);
  if (!allowed || !Array.isArray(list)) return list;
  return list.filter((connection) => allowed.includes(toConnectionId(connection?.id)));
};
